import Button from '../button/v2/button';
import Icon from '../icons/icon';
import { HStack } from '../layouts/stack.layout';

const styles = {
  wrapper:
    'w-full items-center rounded-full px-3 py-2 border border-light-gray',
  container: 'w-full items-center',
};

type SearchInputProps = {
  value: string;
  set: Function;
  update?: Function;
  placeholder: string;
};

export default function SearchInput(props: SearchInputProps) {
  const { value, set, update, placeholder } = props;

  const handleOnChange = (e: any) => {
    set(e.target.value);
    // update the search results
    // update(value);
  };
  const resetSearchValue = () => {
    // reset the search value
    set('');
  };
  return (
    <HStack extensions={styles.wrapper}>
      <HStack extensions={styles.container} gap="sm">
        <Icon icon="search" size="md" />
        <input
          value={value}
          onChange={handleOnChange}
          type="text"
          className="bg-transparent"
          placeholder={placeholder}
        />
      </HStack>
      {value.length > 0 && (
        <Button
          asIcon="close"
          size="sm"
          withButtonStyle
          onClick={resetSearchValue}
        />
      )}
    </HStack>
  );
}
